import {DomainData} from "../../shared/index";

export abstract class DataServiceInterface {
  public abstract apiUrl: string;
  public abstract messageHubUrl: string;
  public abstract googleMapsAPIKey: string;
  public abstract globals: DomainData;
}
